import React from 'react'
import { twMerge } from 'tailwind-merge'

const COMMON_LAYOUT_SWITCHER_BUTTON_LINE_CLASSNAME =
  'h-4.5 min-w-14 rounded-full'

export const LightLayoutSwitcherButtonLine = ({
  className,
}: {
  className?: string
}) => (
  <div
    className={twMerge(
      COMMON_LAYOUT_SWITCHER_BUTTON_LINE_CLASSNAME,
      'bg-bgTertiary',
      className,
    )}
  />
)

export const DarkLayoutSwitcherButtonLine = ({
  className,
}: {
  className?: string
}) => (
  <div
    className={twMerge(
      COMMON_LAYOUT_SWITCHER_BUTTON_LINE_CLASSNAME,
      'bg-gray-800',
      className,
    )}
  />
)
